var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationTab(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Notification_02"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Notification_02",
    "data-name": "Notification 02",
    clipPath: "url(#clip-Notification_02)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_3",
    "data-name": "Subtraction 3",
    d: "M19864.7,20416.748a.492.492,0,0,1-.471-.5v-1h-6.006a.665.665,0,0,1-.578-.3l-.01-.025-.021-.021a.631.631,0,0,1,.006-.727l.568-.959.01-.016a.351.351,0,0,1,.021-.039l0-.006a.058.058,0,0,0,.008-.016.917.917,0,0,0,.1-.523v-5.76a6.233,6.233,0,0,1,5.58-6.035h.318v-.83a.5.5,0,0,1,1,0v.809l.225.021a6.059,6.059,0,0,1,3.7,1.7l.006.01a5.674,5.674,0,0,1,1.992,4.242v5.9a1.142,1.142,0,0,0,.176.574l.578.877a1.02,1.02,0,0,1-.031.809.8.8,0,0,1-.666.313h-6.01v1A.486.486,0,0,1,19864.7,20416.748Zm-.082-14.947c-.2,0-.385.008-.578.025a5.163,5.163,0,0,0-4.74,5.037v5.9a2.339,2.339,0,0,1-.268.9l0,.006-.168.268v.354h12.092l-.486-.492a2.116,2.116,0,0,1-.309-1.092v-5.9a4.629,4.629,0,0,0-1.639-3.594A5.977,5.977,0,0,0,19864.615,20401.8Z",
    transform: "translate(-19855.25 -20399.25)",
    fill: "#c06c84"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationTab);
export default __webpack_public_path__ + "static/media/notification-tab.df3969fe526cad9f9d4e4a86cc39e197.svg";
export { ForwardRef as ReactComponent };